import { trimScript } from './trimScript';
import { validateScript } from './validateScript';

export const generateClickHandler = (script: string, domain: string) => {
  const trimmedScript = trimScript(script);
  const validationErrors = validateScript(trimmedScript);

  if (validationErrors.length > 0) {
    console.error('Validation errors in AppsFlyer script:', validationErrors);
    return '';
  }

  const handleClickString = `(event) => {
      if (!(event.target instanceof HTMLAnchorElement)) return;
      if (!event.target.href || !event.target.href.includes('@domain')) return;
      if (typeof window.AF_SMART_SCRIPT === 'undefined') {
        console.error('AppsFlyer SmartScript SDK is not loaded.');
        window.location.href = event.target.href;
        return;
      }
      const processedUrl = new URL(event.target.href);
      const oneLinkURL = processedUrl.origin + processedUrl.pathname;
      event.preventDefault();
      // START INJECTED CODE
      @replaceWithInjectedCode;
      // END INJECTED CODE
      // Assuming result is the object returned by the AppsFlyer SDK
      const resultUrl = new URL(result.clickURL);
      // Add the original query parameters to the result URL
      for (const [key, value] of processedUrl.searchParams.entries()) {
        resultUrl.searchParams.set(key, value);
      }
      if (event.ctrlKey || event.metaKey || event.button === 1) {
        // Open in a new tab
        window.open(resultUrl.toString(), '_blank');
      } else {
        // Replace the current page
        window.location.href = resultUrl.toString();
      }
  }`;

  return handleClickString
    .replace('@replaceWithInjectedCode;', trimmedScript)
    .replaceAll('@domain', domain);
};
